<template>
    <form class="edit-check">
        <div class="row responsive-label">
            <div class="col-sm-12 col-md-3">
                <label for="number">Phone Number</label>
            </div>
            <div class="col-sm-12 col-md">
                <input type="text" id="url" v-model="properties.PhoneNumber">
                <p class="helper"> {{ properties.PhoneNumber }} Please remember to include the country code.</p>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    props: ["properties"],
    name: 'notificators-sms-form',
    data() {
        return {}
    },
}
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/notificators/SMSForm.vue